// extracted by css-extract-rspack-plugin
export default {"error":"MsgPreview_error__lydXn"};